<template>
  <v-app>
    <v-main>
      <v-container fluid>
        <v-row>
          <v-col>
            <v-table fixed-header>
              <thead>
                <tr>
                  <th class="text-left">Сотрудник</th>
                  <th class="text-center pt-2">
                    <v-text-field
                      label="Введите фамилию"
                      variant="outlined"
                      class="rounded-xl"
                      v-model="needText"
                      @input="getNeedEmploye"
                    ></v-text-field>
                  </th>
                  <th class="text-right">Рейтинг</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="employee in filterEmployees"
                  :key="employee.user.avatar"
                >
                  <td class="text-left">
                    <div :class="isDesctop ? 'employee-desctop' : ''">
                      <v-avatar :image="employee.user.avatar"></v-avatar>

                      <div>
                        {{
                          `${employee.user.firstName} ${employee.user.lastName}`
                        }}
                      </div>
                    </div>
                  </td>
                  <td class="text-center">
                    <div
                      class="ma-2 icon-group positive"
                      v-show="employee.ratingList.positive.length > 0"
                    >
                      <v-tooltip
                        v-model="item.show"
                        location="bottom"
                        v-for="(item, index) in employee.ratingList.positive"
                        :key="index"
                      >
                        <template v-slot:activator="{ props }">
                          <img
                            @click="item.show = !item.show"
                            v-bind="props"
                            class="icon"
                            :src="item.image"
                          />
                        </template>
                        <span>{{ `${item.name}: ${item.amount}` }}</span>
                      </v-tooltip>
                    </div>
                    <div
                      class="ma-2 icon-group negative"
                      v-show="employee.ratingList.negative.length > 0"
                    >
                      <v-tooltip
                        v-model="item.show"
                        location="bottom"
                        v-for="(item, index) in employee.ratingList.negative"
                        :key="index"
                      >
                        <template v-slot:activator="{ props }">
                          <img
                            @click="item.show = !item.show"
                            v-bind="props"
                            class="icon"
                            :src="item.image"
                          />
                        </template>
                        <span>{{ `${item.name}: ${item.amount}` }}</span>
                      </v-tooltip>
                    </div>
                  </td>
                  <td class="text-right">{{ employee.ratingTotal }}</td>
                </tr>
              </tbody>
            </v-table>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
//import { BX24 } from "bx24";
//import axios from "axios";

export default {
  name: "App",
  data: () => ({
    needText: "",
    isDesctop: false,
    width: 0,
    url: "https://bitrix24.nskbowling.ru/rest/573/pay6t1z9ytpioxcy/",
    auth: "",
    show: false,
    filterEmployees: [],
    employees: [
      {
        user: {
          avatar:
            "https://bitrix24.nskbowling.ru/upload/upload/main/3c3/3c3777198f71a06065a6f77065dc29f3/ddda749d291ed906be5277abee9cbe0a.png", // (string)
          firstName: "Эльяр", // (string)
          lastName: "Арзыкаев", // (string)
        },
        ratingList: {
          positive: [
            {
              type: "positive", // (positive/negative) (string)
              name: "Отзыв положительный", // (string)
              amount: 5, // (int)
              image:
                "https://bitrix24.nskbowling.ru/local/modules/bizupgrade.rating/install/images/feedback_is_positive.svg", // (string)
            },
            {
              type: "positive", // (positive/negative) (string)
              name: "Отзыв положительный", // (string)
              amount: 5, // (int)
              image:
                "https://bitrix24.nskbowling.ru/local/modules/bizupgrade.rating/install/images/feedback_is_positive.svg", // (string)
            },
          ],
          negative: [
            {
              type: "positive", // (positive/negative) (string)
              name: "Отзыв положительный", // (string)
              amount: 5, // (int)
              image:
                "https://bitrix24.nskbowling.ru/local/modules/bizupgrade.rating/install/images/feedback_is_positive.svg", // (string)
            },
            {
              type: "positive", // (positive/negative) (string)
              name: "Отзыв положительный", // (string)
              amount: 5, // (int)
              image:
                "https://bitrix24.nskbowling.ru/local/modules/bizupgrade.rating/install/images/feedback_is_positive.svg", // (string)
            },
          ],
        },

        ratingTotal: 10, // (int)
      },
      {
        user: {
          avatar:
            "https://bitrix24.nskbowling.ru/upload/upload/main/3c3/3c3777198f71a06065a6f77065dc29f3/ddda749d291ed906be5277abee9cbe0a.png", // (string)
          firstName: "Александр", // (string)
          lastName: "Геккель", // (string)
        },
        ratingList: {
          positive: [
            {
              type: "positive", // (positive/negative) (string)
              name: "Отзыв положительный", // (string)
              amount: 5, // (int)
              image:
                "https://bitrix24.nskbowling.ru/local/modules/bizupgrade.rating/install/images/feedback_is_positive.svg", // (string)
            },
            {
              type: "positive", // (positive/negative) (string)
              name: "Отзыв положительный", // (string)
              amount: 5, // (int)
              image:
                "https://bitrix24.nskbowling.ru/local/modules/bizupgrade.rating/install/images/feedback_is_positive.svg", // (string)
            },
          ],
          negative: [
            {
              type: "positive", // (positive/negative) (string)
              name: "Отзыв положительный", // (string)
              amount: 5, // (int)
              image:
                "https://bitrix24.nskbowling.ru/local/modules/bizupgrade.rating/install/images/feedback_is_positive.svg", // (string)
            },
            {
              type: "positive", // (positive/negative) (string)
              name: "Отзыв положительный", // (string)
              amount: 5, // (int)
              image:
                "https://bitrix24.nskbowling.ru/local/modules/bizupgrade.rating/install/images/feedback_is_positive.svg", // (string)
            },
          ],
        },

        ratingTotal: 15, // (int)
      },
    ],
  }),
  methods: {
    getNeedEmploye() {
      console.log(this.needText);
      if (this.needText.length > 3) {
        this.filterEmployees = this.employees.filter((e) =>
          e.user.lastName.toLowerCase().includes(this.needText.toLowerCase())
        );
      } else {
        this.filterEmployees = this.employees;
      }
    },
    async getEmployes() {
      this.filterEmployees = this.employees;
      /*this.employees = await axios.post(
        this.url + "bizupgrade.rating.getRatings",
        {
          auth: this.auth,
        }
      );
      console.log(this.employees, "employees");
      this.filterEmployees = this.employees;*/
    },
  },
  watch: {
    width(newValue) {
      this.isDesctop = newValue > 700 ? true : false;
    },
  },
  async mounted() {
    /*const bx24 = new BX24();
    this.auth = await bx24.getAuth();
    this.url = `https://${this.auth.DOMAIN}/rest/`;*/

    window.addEventListener("resize", () => {
      this.width = document.documentElement.clientWidth;
    });
    await this.getEmployes();
  },
};
</script>
<style scoped>
.employee-desctop {
  display: inline-flex;
  align-items: center;
}
.icon {
  border-radius: 50%;
  margin-right: 3px;
}
.icon-group {
  display: inline-block;
  padding-top: 6px;
  padding-bottom: 2px;
  padding-left: 2px;
  border-radius: 20px;
}
.positive {
  background-color: rgba(136, 218, 26, 0.24);
}
.negative {
  background-color: gainsboro;
}
</style>
